import IPage from "../../../interfaces/page";
import RegisterFormComponent from "../../Components/RegisterForm/RegisterForm.component";
import PublicLayout from "../../layouts/Public/Public.layout";

const RegisterPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <PublicLayout component={RegisterFormComponent} />
}

export default RegisterPage;